(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('moment')) :
  typeof define === 'function' && define.amd ? define(['exports', 'moment'], factory) :
  (global = global || self, factory(global['coolcamper-common'] = {}, global.moment));
}(this, function (exports, moment_) { 'use strict';

  var moment = moment_;
  var roundNumber = function (value, decimals) {
      // @ts-ignore-line
      var roundedNumber = Math.round(value + "e" + decimals);
      return Number(roundedNumber + "e-" + decimals);
  };
  var parseDateToMoment = function (date, format) {
      if (!date) {
          return null;
      }
      var momentDate = moment(date, format);
      var utcOffset = momentDate.utcOffset();
      var safeDate = momentDate.utc().add(utcOffset, "m");
      safeDate.milliseconds(0);
      safeDate.seconds(0);
      safeDate.minutes(0);
      safeDate.hours(0);
      return safeDate;
  };
  var getNoOfDays = function (startDate, endDate) {
      var parsedStartDate = parseDateToMoment(startDate);
      var parsedEndDate = parseDateToMoment(endDate);
      return parsedStartDate && parsedEndDate
          ? parsedEndDate.diff(parsedStartDate, "days") + 1
          : 0;
  };
  var isEmailValid = function (email) {
      // source: https://emailregex.com/
      var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
  };
  var isPhoneValid = function (phone) {
      // Valid formats:
      // XXXX-XXX-XXX
      // XXXX.XXX.XXX
      // XXXX XXX XXX
      // XXXXXXXXXX
      var regex = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
      return regex.test(phone);
  };
  var isFirstNameValid = function (firstName) {
      return firstName && firstName.length > 1;
  };
  var isLastNameValid = function (lastName) {
      return lastName && lastName.length > 1;
  };
  // TODO - implement function
  var formatPhoneForDisplay = function (phone) { return phone; };

  var highSeasonStartDate = "01-06-" + new Date().getFullYear();
  var highSeasonEndDate = "30-09-" + new Date().getFullYear();
  var pricesData = {
      datesFormat: "DD-MM-YYYY",
      highSeasonInterval: [highSeasonStartDate, highSeasonEndDate],
      highSeasonPricePerDay: 150,
      lowSeasonPricePerDay: 100,
      minRentalDays: 3,
      deposit: 500,
      discounts: {
          temporary: {
              highSeasonPercent: 0,
              lowSeasonPercent: 0
          },
          fixedInterval: [],
          minBookingDays: [
          // {
          //   minDays: 10,
          //   percent: 5
          // }
          ]
      }
  };

  var moment$1 = moment_;
  var getPrices = function (startDate, endDate, datesFormat, pricesData$1) {
      if (pricesData$1 === void 0) { pricesData$1 = pricesData; }
      // parse dates to moment objects
      var momentStartDate = parseDateToMoment(startDate, datesFormat);
      var momentEndDate = parseDateToMoment(endDate, datesFormat);
      var totalNoOfDays = getNoOfDays(momentStartDate, momentEndDate);
      if (totalNoOfDays <= 0)
          return null;
      var highSeasonStart = moment$1.utc(pricesData$1.highSeasonInterval[0], pricesData$1.datesFormat);
      var highSeasonEnd = moment$1.utc(pricesData$1.highSeasonInterval[1], pricesData$1.datesFormat);
      var highSeasonDays = getNoOfHighSeasonDays(momentStartDate, momentEndDate, highSeasonStart, highSeasonEnd);
      var lowSeasonDays = totalNoOfDays - highSeasonDays;
      var highSeasonPrice = pricesData$1.highSeasonPricePerDay * highSeasonDays;
      var lowSeasonPrice = pricesData$1.lowSeasonPricePerDay * lowSeasonDays;
      var totalPrice = highSeasonPrice + lowSeasonPrice;
      var eligibleDiscounts = getEligibleDiscounts(momentStartDate, momentEndDate, totalNoOfDays, highSeasonPrice, lowSeasonPrice, pricesData$1);
      var highSeasonDiscountAmount = eligibleDiscounts.reduce(function (sum, discount) {
          return sum + discount.highSeasonAmount;
      }, 0);
      var lowSeasonDiscountAmount = eligibleDiscounts.reduce(function (sum, discount) {
          return sum + discount.lowSeasonAmount;
      }, 0);
      var highSeasonPriceWithDiscount = highSeasonPrice - highSeasonDiscountAmount;
      var lowSeasonPriceWithDiscount = lowSeasonPrice - lowSeasonDiscountAmount;
      var totalDiscountAmount = highSeasonDiscountAmount + lowSeasonDiscountAmount;
      var totalPriceWithDiscount = totalPrice - totalDiscountAmount;
      var averagePricePerDay = roundNumber(totalPrice / totalNoOfDays, 2);
      return {
          startDate: momentStartDate,
          endDate: momentEndDate,
          highSeasonDays: highSeasonDays,
          lowSeasonDays: lowSeasonDays,
          totalNoOfDays: totalNoOfDays,
          lowSeasonPrice: lowSeasonPrice,
          highSeasonPrice: highSeasonPrice,
          totalPrice: totalPrice,
          highSeasonPriceWithDiscount: highSeasonPriceWithDiscount,
          lowSeasonPriceWithDiscount: lowSeasonPriceWithDiscount,
          totalPriceWithDiscount: totalPriceWithDiscount,
          discounts: eligibleDiscounts.slice(),
          deposit: pricesData$1.deposit,
          highSeasonPricePerDay: pricesData$1.highSeasonPricePerDay,
          lowSeasonPricePerDay: pricesData$1.lowSeasonPricePerDay,
          averagePricePerDay: averagePricePerDay,
          highSeasonStart: highSeasonStart.format(pricesData$1.datesFormat || "MM-DD-YYYY"),
          highSeasonEnd: highSeasonEnd.format(pricesData$1.datesFormat || "MM-DD-YYYY")
      };
  };
  var getNoOfHighSeasonDays = function (startDate, endDate, highSeasonStart, highSeasonEnd) {
      var currentYear = moment$1.utc().year();
      var minEnd = moment$1.min(highSeasonEnd.year(currentYear), endDate.year(currentYear));
      var maxStart = moment$1.max(highSeasonStart.year(currentYear), startDate.year(currentYear));
      // Use this when calculate nights and not days
      // const isEndDateAfterHighSeasonEnd = endDate
      //   .year(currentYear)
      //   .isAfter(highSeasonEnd.year(currentYear));
      return Math.max(minEnd.diff(maxStart, "days") + 1, 0);
  };
  /**
   * Returns the eligible discount
   * @param {moment} startDate The start date of the requested booking
   * @param {moment} endDate The end date of the requested booking
   * @param {number} totalNoOfDays Total number of days booked
   */
  var getEligibleDiscounts = function (startDate, endDate, totalNoOfDays, highSeasonPrice, lowSeasonPrice, pricesData) {
      var discounts = [];
      // get temporary discount
      var temporaryDiscounts = getTemporaryDiscounts(highSeasonPrice, lowSeasonPrice, pricesData);
      var hasTempHighSeasonDiscount = temporaryDiscounts &&
          temporaryDiscounts.filter(function (discount) { return discount.highSeasonAmount > 0; })
              .length > 0;
      var hasTempLowSeasonDiscount = temporaryDiscounts &&
          temporaryDiscounts.filter(function (discount) { return discount.lowSeasonAmount > 0; }).length >
              0;
      if (hasTempHighSeasonDiscount && hasTempLowSeasonDiscount) {
          return temporaryDiscounts;
      }
      if (temporaryDiscounts && temporaryDiscounts.length > 0) {
          discounts.push.apply(discounts, temporaryDiscounts);
      }
      // get min booking days discount
      var minBookingDaysDiscount = getMinBookingDaysDiscount(totalNoOfDays, highSeasonPrice, lowSeasonPrice, !hasTempHighSeasonDiscount, !hasTempLowSeasonDiscount, pricesData);
      if (minBookingDaysDiscount) {
          discounts.push(minBookingDaysDiscount);
      }
      return discounts;
  };
  var getTemporaryDiscounts = function (highSeasonPrice, lowSeasonPrice, pricesData) {
      var hasTempDiscounts = pricesData.discounts && pricesData.discounts.temporary;
      var highSeasonPercent = hasTempDiscounts
          ? pricesData.discounts.temporary.highSeasonPercent
          : 0;
      var lowSeasonPercent = hasTempDiscounts
          ? pricesData.discounts.temporary.lowSeasonPercent
          : 0;
      var hasHighSeasonDiscount = highSeasonPrice > 0 && highSeasonPercent > 0;
      var hasLowSeasonDiscount = lowSeasonPrice > 0 && lowSeasonPercent > 0;
      if (!hasHighSeasonDiscount && !hasLowSeasonDiscount) {
          return null;
      }
      var discounts = [];
      if (hasHighSeasonDiscount) {
          discounts.push({
              highSeasonAmount: calculatePercentDiscountAmount(highSeasonPrice, highSeasonPercent),
              highSeasonPercent: highSeasonPercent,
              lowSeasonAmount: 0,
              lowSeasonPercent: lowSeasonPercent,
              message: highSeasonPercent + "% discount in sezon"
          });
      }
      if (hasLowSeasonDiscount) {
          discounts.push({
              highSeasonAmount: 0,
              highSeasonPercent: highSeasonPercent,
              lowSeasonAmount: calculatePercentDiscountAmount(lowSeasonPrice, lowSeasonPercent),
              lowSeasonPercent: lowSeasonPercent,
              message: lowSeasonPercent + "% discount in extra-sezon"
          });
      }
      return discounts;
  };
  var getMinBookingDaysDiscount = function (totalNoOfDays, highSeasonPrice, lowSeasonPrice, canApplyHighSeasonDiscount, canApplyLowSeasonDiscount, pricesData) {
      var discount;
      if (pricesData.discounts &&
          pricesData.discounts.minBookingDays &&
          pricesData.discounts.minBookingDays.length > 0) {
          for (var i = 0; i < pricesData.discounts.minBookingDays.length; i++) {
              var currDiscount = pricesData.discounts.minBookingDays[i];
              if (currDiscount.minDays <= totalNoOfDays &&
                  (!discount ||
                      !discount.minDays ||
                      currDiscount.minDays > discount.minDays))
                  discount = currDiscount;
          }
      }
      var hasHighSeasonDiscount = discount && highSeasonPrice > 0 && canApplyHighSeasonDiscount;
      var hasLowSeasonDiscount = discount && lowSeasonPrice > 0 && canApplyLowSeasonDiscount;
      if (hasHighSeasonDiscount || hasLowSeasonDiscount) {
          return {
              highSeasonPercent: discount.percent,
              lowSeasonPercent: discount.percent,
              highSeasonAmount: canApplyHighSeasonDiscount
                  ? calculatePercentDiscountAmount(highSeasonPrice, discount.percent)
                  : 0,
              lowSeasonAmount: canApplyLowSeasonDiscount
                  ? calculatePercentDiscountAmount(lowSeasonPrice, discount.percent)
                  : 0,
              message: discount.percent + "% discount",
              tooltip: "Pentru " + discount.minDays + " sau mai multe zile se aplica un discount de " + discount.percent + "%"
          };
      }
      return null;
  };
  var calculatePercentDiscountAmount = function (price, percent) {
      if (price <= 0) {
          return 0;
      }
      return roundNumber((price * percent) / 100, 2);
  };

  exports.formatPhoneForDisplay = formatPhoneForDisplay;
  exports.getNoOfDays = getNoOfDays;
  exports.getPrices = getPrices;
  exports.isEmailValid = isEmailValid;
  exports.isFirstNameValid = isFirstNameValid;
  exports.isLastNameValid = isLastNameValid;
  exports.isPhoneValid = isPhoneValid;
  exports.pricesData = pricesData;
  exports.roundNumber = roundNumber;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
